const videoBlock = async () => {
  const videoBlocks = document.querySelectorAll('[js-video-block]');

  if (!videoBlocks) {
    return;
  }

  const tag = document.createElement('script');

  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  Array.prototype.forEach.call(videoBlocks, el => {
    const video = el.querySelectorAll('[js-video-block-video]')[0];
    const videoId = video.getAttribute('js-video-block-video');

    let player;

    function onPlayerStateChange(event) {
      if (event.data === 2) {
        el.classList.remove('play');
      } else {
        el.classList.add('play');
      }
    }

    setTimeout(() => {
      /* eslint-disable */
      player = new YT.Player(video, {
        videoId: videoId,
        events: {
          onStateChange: onPlayerStateChange
        }
      });
      /* eslint-enable */
    }, 1000);

    el.addEventListener('click', event => {
      const parent = event.target.closest('[js-video-block]');
      parent.classList.add('play');
      player.playVideo();
    });
  });
};

export default videoBlock;
